export const SETTINGS = '/users/settings'
export const CHANGE_PASSWORD = '/users/settings/password'
export const PASSWORD_RESET = '/users/password/recover'
export const PASSWORD_RESET_CONFIRMATION = '/users/password/recover/:token'
export const ACCEPT_INVITATION = '/users/invitation/accept'
export const SETUP_MFA_ENFORCED = '/users/settings/mfa'
export const SETUP_MFA = '/users/settings/mfa/setup'
export const SETUP_WEB_AUTHN = '/users/settings/mfa/setup/webauthn'
export const SETUP_TOTP = '/users/settings/mfa/setup/totp'
export const DISABLE_MFA = '/users/settings/mfa/disable'
